<template>
  <div>
    <LaboratoryFilter
      v-if="$can('filter', 'laboratories')"
      :loading="loading"
      @searchFilter="searchFilter"
      @filterPage="filterPage"
    />
    <b-card>
      <TitleTable titleTable="Laboratories" iconTable="fas fa-disease" />
      <div class="m-1">
        <LaboratoryEdit
          v-if="isEditLaboratorySidebarActive"
          :is-edit-laboratory-sidebar-active.sync="
            isEditLaboratorySidebarActive
          "
          :itemEdit="itemEdit"
          :itemsCategories="itemsCategories"
          @editLaboratorySuccess="editLaboratorySuccess"
        />
        <LaboratoryAdd
          v-if="isAddNewLaboratorySidebarActive"
          :is-add-new-laboratory-sidebar-active.sync="
            isAddNewLaboratorySidebarActive
          "
          :itemsCategories="itemsCategories"
          @createLaboratory="createLaboratory"
        />
        <!-- Table Top -->
        <b-row>
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <treeselect
              v-model="perPage"
              :options="perPageOptions"
              :clearable="true"
              class="w-25"
            />
          </b-col>
          <!-- {{ $t("Search") }} -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <GoBack class="mr-2" />
              <b-button
                v-if="$can('store', 'laboratorys')"
                variant="primary"
                @click="isAddNewLaboratorySidebarActive = true"
                :disabled="loading"
              >
                <span v-if="!loading" class="text-nowrap"
                  >{{ $t("Add") }} Laboratory</span
                >
                <span v-else>
                  <SpinnerLoading />
                </span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table
        :items="items"
        :fields="fields"
        hover
        bordered
        responsive
        primary-key="id"
        class="position-relative min-height-table"
        show-empty
        empty-text="No matching records found"
      >
        <template #cell(categories)="data">
          {{
            data.item.categories.length > 0 ? data.item.categories[0].name : "-"
          }}
        </template>
        <template #cell(status)="data">
          <div class="text-nowrap">
            <span class="align-text-top text-capitalize">{{
              data.item.status ? $t("Active") : $t("Inactive")
            }}</span>
          </div>
        </template>
        <template #cell(actions)="data">
          <b-button
            v-if="$can('update', 'laboratorys')"
            variant="outline-primary"
            class="btn-icon btn-circle border-0"
            v-b-tooltip.hover.top="'Edit'"
            @click="editLaboratory(data.item)"
          >
            <i class="fas fa-pen icon-nm"></i>
          </b-button>

          <b-button
            v-if="$can('destroy', 'laboratorys')"
            variant="outline-danger"
            class="btn-icon btn-circle border-0"
            v-b-tooltip.hover.top="'Delete'"
            @click="deleteLaboratory(data.item)"
          >
            <i class="fas fa-trash-alt icon-nm"></i>
          </b-button>
        </template>
      </b-table>
      <PaginationTable
        :dataMeta="dataMeta"
        :totalUsers="totalUsers"
        :perPage="perPage"
        :currentPage="currentPage"
        @page-changed="pageChanged"
      />
    </b-card>
    <ToastNotification ref="toast" />
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BTable,
  BBadge,
  BAvatar,
  BButton,
  VBTooltip,
} from "bootstrap-vue";
import axiosAC from "@/core/services/apiInsurance/admin/consults/laboratories";
import axiosACL from "@/core/services/apiInsurance/admin/consults/laboratoryCategories";

import ToastNotification from "@/components/ToastNotification";
import SpinnerLoading from "@/components/SpinnerLoading";
import PaginationTable from "@/components/PaginationTable";
import TitleTable from "@/components/TitleTable.vue";
import GoBack from "@/components/ButtonBack.vue";
import Swal from "sweetalert2";

import LaboratoryEdit from "./LaboratoryEdit.vue";
import LaboratoryAdd from "./LaboratoryAdd.vue";
import LaboratoryFilter from "./LaboratoryFilter.vue";
import { ref } from "@vue/composition-api";
export default {
  components: {
    BCard,
    BRow,
    BCol,
    BTable,
    BBadge,
    BAvatar,
    BButton,
    LaboratoryEdit,
    LaboratoryAdd,
    LaboratoryFilter,
    ToastNotification,
    SpinnerLoading,
    PaginationTable,
    TitleTable,
    GoBack,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      fields: [
        // A virtual column that doesn't exist in items
        "id",
        // A column that needs custom formatting
        { key: "name", label: "Name", sortable: true },
        { key: "code", label: "Code", sortable: true },
        { key: "categories", label: "Category", sortable: true },
        'price_cost',
        { key: "price", label: "Price", sortable: true },
        { key: "status", label: "Status" },
        // A virtual column made up from two fields
        { key: "actions", label: "Actions" },
      ],
      items: null,
      loading: false,
      isEditLaboratorySidebarActive: false,
      isAddNewLaboratorySidebarActive: false,
      itemEdit: null,
      itemsCategories: [],
      dataMeta: { from: 1, to: 1, of: 1 },
      totalUsers: 0,
      perPage: 10,
      currentPage: {
        page: 1,
      },
      perPageOptions: [10, 25, 50, 100].map((i) => ({
        id: i,
        label: `Show ${i} Entries`,
      })),
      filtro: false,
      laboratoryFilter: null,
    };
  },
  mounted() {
    this.getLaboratory();
    axiosACL.categoryLabList(this.perPage).then(({ data }) => {
      this.itemsCategories = data;
    });
  },
  watch: {
    perPage(newVal) {
      if (!this.filtro) {
        this.getLaboratory();
      } else {
        this.searchFilter(this.laboratoryFilter);
      }
    },
  },
  methods: {
    getLaboratory() {
      axiosAC
        .laboratoryList(this.perPage)
        .then(({ data, current_page, total, per_page, ...res }) => {
          this.items = data;
          this.totalUsers = total;
          this.dataMeta.of = total;
          this.dataMeta.from = res.from;
          this.dataMeta.to = res.to;
          this.currentPage.page = current_page;
        });
    },
    editLaboratory(item) {
      this.isEditLaboratorySidebarActive = true;
      this.itemEdit = ref(JSON.parse(JSON.stringify(item)));
    },
    editLaboratorySuccess(value) {
      if (value) {
        this.$refs.toast.success("Type Laboratory updated successfully");
      } else {
        this.$refs.toast.error("Error updating type laboratory");
      }
      this.isEditLaboratorySidebarActive = false;
      this.pageChanged(this.currentPage.page);
    },
    createLaboratory({ status }) {
      if (status) {
        this.$refs.toast.success("Laboratory type added successfully");
      } else {
        this.$refs.toast.danger("Laboratory type not added");
      }
      this.isAddNewLaboratorySidebarActive = false;
      this.pageChanged(this.currentPage.page);
    },
    deleteLaboratory(item) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this",
        icon: "error",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          axiosAC.laboratoryDelete(item.id).then((response) => {
            this.$refs.toast.success(
              "Laboratory type has been deleted successfully"
            );
            this.pageChanged(this.currentPage.page);
          });
        }
      });
    },
    pageChanged(page) {
      if (!this.filtro) {
        axiosAC
          .laboratoryPagination(this.perPage, page)
          .then(({ data, total, current_page, ...res }) => {
            this.items = data;
            this.totalUsers = total;
            this.dataMeta.of = total;
            this.dataMeta.from = res.from;
            this.dataMeta.to = res.to;
            this.currentPage.page = current_page;
          });
      } else {
        axiosAC
          .laboratoryFilterPagination(this.perPage, page, this.laboratoryFilter)
          .then(({ registro: { data, total, current_page, ...res } }) => {
            this.items = data;
            this.totalUsers = total;
            this.dataMeta.of = total;
            this.dataMeta.from = res.from;
            this.dataMeta.to = res.to;
            this.currentPage.page = current_page;
          });
      }
    },
    searchFilter(value) {
      if (this.filtro) {
        this.loading = true;
        this.laboratoryFilter = value;
        axiosAC
          .laboratoryFilter(this.perPage, value)
          .then(({ registro: { data, total, current_page, ...res } }) => {
            this.loading = false;
            this.items = data;
            this.totalUsers = total;
            this.dataMeta.of = total;
            this.dataMeta.from = res.from;
            this.dataMeta.to = res.to;
            this.currentPage.page = current_page;
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        this.getLaboratory();
      }
    },
    filterPage(value) {
      this.filtro = value;
    },
  },
};
</script>

<style></style>
